import { RouteRecordRaw } from 'vue-router'

const Tenants = () =>
  import(/* webpackChunkName: "tenants-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'tenants',
    name: 'tenants',
    component: Tenants,
    meta: {
      title: 'Tenants',
      auth: {
        requiredPermission: 'tenants.view',
        requiredModule: 'tenants',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
